/**
 * Zonas de delivery configuradas en el negocio (sin mapas / APIs externas).
 * @typedef {{ name?: string, keywords?: string[], price?: number, estimated_minutes?: number }} DeliveryZone
 */

function normalizeForMatch(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
}

/**
 * Prioridad: (1) keyword más larga = más específica; (2) misma longitud: orden de aparición
 * de `zones` en config; (3) empate en la misma zona: orden del keyword en el array.
 *
 * @param {string} address
 * @param {DeliveryZone[]} zones
 * @returns {DeliveryZone | null}
 */
export function detectDeliveryZone(address, zones) {
  if (!Array.isArray(zones) || zones.length === 0) return null;
  const a = normalizeForMatch(address);
  if (!a.trim()) return null;

  /** @type {{ zone: DeliveryZone, len: number, zoneIndex: number, kwIndex: number } | null} */
  let best = null;

  for (let zoneIndex = 0; zoneIndex < zones.length; zoneIndex++) {
    const z = zones[zoneIndex];
    const kws = Array.isArray(z?.keywords) ? z.keywords : [];
    for (let kwIndex = 0; kwIndex < kws.length; kwIndex++) {
      const k = normalizeForMatch(String(kws[kwIndex] || '')).trim();
      if (k.length < 2 || !a.includes(k)) continue;
      const len = k.length;
      if (!best) {
        best = { zone: z, len, zoneIndex, kwIndex };
        continue;
      }
      if (len > best.len) {
        best = { zone: z, len, zoneIndex, kwIndex };
        continue;
      }
      if (len < best.len) continue;
      if (zoneIndex < best.zoneIndex) {
        best = { zone: z, len, zoneIndex, kwIndex };
        continue;
      }
      if (zoneIndex > best.zoneIndex) continue;
      if (kwIndex < best.kwIndex) {
        best = { zone: z, len, zoneIndex, kwIndex };
      }
    }
  }

  return best ? best.zone : null;
}

/** @param {object | null | undefined} business */
export function hasDeliveryZones(business) {
  return Array.isArray(business?.delivery_zones) && business.delivery_zones.length > 0;
}
